import React, { useState, useEffect } from 'react';
import { getSolutionBySlug } from '../data/solutions';
import Breadcrumbs from '../components/Breadcrumbs';
import '../styles/Solutions.css';

const SolutionDetailPage = () => {
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const path = typeof window !== 'undefined' ? window.location.pathname : '/solutions';
  const slug = path.replace(/^\/?solutions\/?/, '').replace(/\/$/, '');
  const solution = getSolutionBySlug(slug);

  

  const getImages = () => {
    if (solution.images && solution.images.length > 0) {
      return solution.images;
    }
    return solution.image ? [solution.image] : [];
  };

  const images = getImages();
  const currentImage = images[currentImageIndex] || solution.image;

  if (!solution) {
    return (
      <div className="solutions-detail">
        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Solutions', href: '/solutions' }, { label: 'Not Found' }]} />
        <div className="solutions-container">
          <h1>Solution not found</h1>
          <p>The requested solution does not exist.</p>
          <p><a href="/solutions">Back to Solutions</a></p>
        </div>
      </div>
    );
  }

  return (
    <div className="solutions-detail">
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Solutions', href: '/solutions/' }, { label: solution.title }]} />
      <div className="solution-template">
        <p className="solution-intro">
          {solution.intro}
        </p>
        
        <div className="solution-content">
          <div className="solution-text">
            <div className="solution-body">
              {solution.body && solution.body.map((p, idx) => (
                <p key={idx} dangerouslySetInnerHTML={{ __html: p }} />
              ))}
            </div>

            {Array.isArray(solution.features) && solution.features.length > 0 && (
              <div className="solution-features">
                <h3>Key Features</h3>
                <ul>
                  {solution.features.map((feature, idx) => (
                    <li key={idx}><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>{feature}</li>
                  ))}
                </ul>
              </div>
            )}

          <div className="solution-cta">
            {solution.productsLink && (
              <a href={solution.productsLink} className="cta-button secondary">Browse Products</a>
            )}
            <a href="/solutions/" className="cta-button secondary">View All Solutions</a>
            <a href="/contact-us/" className="cta-button">Contact Us <span>✈</span></a>
          </div>
          </div>
          
          <div className="solution-detail-image">
            <div className="image-carousel">
              <div className="carousel-container">
                <img 
                  src={currentImage} 
                  alt={`${solution.title} - Image ${currentImageIndex + 1}`}
                  onClick={() => setIsImageOpen(true)}
                  style={{cursor: 'pointer'}}
                  className="carousel-image"
                />
                
                {images.length > 1 && (
                  <div className="carousel-indicators">
                    {images.map((_, index) => (
                      <button
                        key={index}
                        className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                        onClick={() => setCurrentImageIndex(index)}
                        aria-label={`View image ${index + 1}`}
                      />
                    ))}
                  </div>
                )}
                
                {images.length > 1 && (
                  <>
                    <button 
                      className="carousel-nav prev"
                      onClick={() => setCurrentImageIndex((prev) => 
                        prev === 0 ? images.length - 1 : prev - 1
                      )}
                      aria-label="Previous image"
                    >
                      <i className="fas fa-chevron-left"></i>
                    </button>
                    <button 
                      className="carousel-nav next"
                      onClick={() => setCurrentImageIndex((prev) => 
                        (prev + 1) % images.length
                      )}
                      aria-label="Next image"
                    >
                      <i className="fas fa-chevron-right"></i>
                    </button>
                  </>
                )}
              </div>
              
              {images.length > 1 && (
                <div className="image-counter">
                  {currentImageIndex + 1} / {images.length}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isImageOpen && (
        <div className="image-modal" role="dialog" aria-modal="true" onClick={() => setIsImageOpen(false)}>
          <div className="image-modal-inner" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal-close" onClick={() => setIsImageOpen(false)} aria-label="Close image">×</button>
            <img 
              src={currentImage} 
              alt={`${solution.title} - Image ${currentImageIndex + 1}`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SolutionDetailPage;




